import { useQuery } from "@tanstack/react-query";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";

// Who invited you — the List's Owner's email. The caller decides `enabled`
// (an unanswered Invitation is the only time this is shown). Null means
// either the Owner's account is gone or the caller can't see the List.
export async function fetchListOwnerEmail(listId: string): Promise<string | null> {
  const { data, error } = await supabase.rpc("list_owner_email", { p_list_id: listId });
  if (error) throw error;
  return (data as string | null) ?? null;
}

export function useListOwnerEmail(listId: string | null | undefined, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.listOwnerEmail(listId ?? ""),
    queryFn: () => fetchListOwnerEmail(listId as string),
    enabled: enabled && !!listId,
  });
}
